/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { render } from 'react-dom';
import HomeLandingPage from './HomeLandingPage';

render(<HomeLandingPage />,
	document.getElementById('home-landing-page'));
/* eslint-enable */
